import createIcon from '../../createIcon';

/**
 * @component @name CalendarMonth
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEgxOFYySDE2VjRIOFYySDZWNEg1QzMuODkgNCAzLjAxIDQuOSAzLjAxIDZMMyAyMEMzIDIxLjEgMy44OSAyMiA1IDIySDE5QzIwLjEgMjIgMjEgMjEuMSAyMSAyMFY2QzIxIDQuOSAyMC4xIDQgMTkgNFpNMTkgMjBINVYxMEgxOVYyMFpNOSAxNEg3VjEySDlWMTRaTTEzIDE0SDExVjEySDEzVjE0Wk0xNyAxNEgxNVYxMkgxN1YxNFpNOSAxOEg3VjE2SDlWMThaTTEzIDE4SDExVjE2SDEzVjE4Wk0xNyAxOEgxNVYxNkgxN1YxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CalendarMonth = createIcon('CalendarMonth', [
  [
    'path',
    {
      d: 'M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z',
      key: 'tsfgzp',
    },
  ],
]);

export default CalendarMonth;
